import React from 'react';
import styles from './styles.module.css';

export default ({ className, children }) => {
  return (
    <div
      className={
        className ? `${className} ${styles.container}` : styles.container
      }
    >
      <div className={styles.square} />
      <div className={styles.children}>{children}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/square/index.js